module.exports = __webpack_public_path__ + "img/avatar_girl.e7e82f4c.png";